export const themeModes = Object.freeze({
  light: "light",
  dark: "dark",
});

export const defaultThemeMode = themeModes.light;

export function isSupportedThemeMode(mode) {
  return Object.values(themeModes).includes(mode);
}
